"use client";

import { RadioGroup } from "@/components/ui/radio-group";
import { RadioGroupItem } from "@radix-ui/react-radio-group";

import { Paragraph } from "@/components/ui/typography";
import { FormField } from "@/components/ui/form";

import CourseSection from "./course-section";

import { cn } from "@/lib/utils";

function LearningMode({ value, children }) {
  return (
    <RadioGroupItem
      className={cn(
        "border border-grayscale-input bg-grayscale p-4 rounded-lg",
        "data-[state=checked]:bg-primary-bg data-[state=checked]:border-primary"
      )}
      value={value}
    >
      <Paragraph variant="b3" weight="sb" className="text-left">
        {children}
      </Paragraph>
    </RadioGroupItem>
  );
}

function CourseMode({ haveOnlineCourse, haveOfflineCourse }) {
  if (!haveOnlineCourse || !haveOfflineCourse) return null;

  return (
    <CourseSection id="mode-of-learning" title="Mode of Learning">
      <FormField
        name="mode"
        render={({ field }) => (
          <RadioGroup
            className="grid grid-cols-3 gap-x-4"
            onValueChange={field.onChange}
            defaultValue={field.value}
            {...field}
          >
            <LearningMode value="online">Online</LearningMode>
            <LearningMode value="offline">Offline</LearningMode>
          </RadioGroup>
        )}
      />
    </CourseSection>
  );
}

export default CourseMode;
